import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../../shared/domain/users/user.model';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Principal } from '../../../shared/auth/principal.service';
import { SnackBarService } from '../../../shared/services/snackbar.service';
import { GlobalSpinnerService } from '../../../shared/components/loader-service/global-spinner.service';
import { NoteWithFileEditorDialogComponent } from '../../../shared/components/dialogs/note-with-file-editor-dialog.component';
import { ConfirmDialogComponent } from '../../../shared/components/dialogs/confirm-dialog.component';
import { PublisherNote } from '../../../shared/domain/publisher-note.model';
import { AdStatsPublishersService } from '../../../shared/services/ad-stats-publishers.service';

@Component({
  selector: 'cm-publisher-notes',
  templateUrl: './publisher-notes.component.html',
  styleUrls: ['./publisher-notes.component.scss']
})
export class PublisherNotesComponent implements OnInit {
  @Input()
  publisherId: string;
  notes: PublisherNote[];
  currentUser: User;
  loading = true;

  constructor(private matDialog: MatDialog,
    private service: AdStatsPublishersService,
    private principalService: Principal,
    private sbs: SnackBarService,
    private gss: GlobalSpinnerService
  ) {
  }

  ngOnInit(): void {
    this.currentUser = this.principalService.getUser();
    this.refresh();
  }

  refresh() {
    this.loading = true;
    this.service.getPublisherNotes(this.publisherId).subscribe(next => {
      this.loading = false;
      this.notes = next;
    }, () => {
      this.loading = false;
    });
  }

  public openNewNoteDialog() {
    const publisherNote = new PublisherNote();
    publisherNote.publisherId = this.publisherId;

    this.matDialog.open(NoteWithFileEditorDialogComponent, <MatDialogConfig>{
      width: '600px',
      data: {
        note: publisherNote
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.refresh();
      }
    });
  }

  openEditDialog(note: PublisherNote) {
    this.matDialog.open(NoteWithFileEditorDialogComponent, <MatDialogConfig>{
      width: '600px',
      data: {
        note: Object.assign({}, note),
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.refresh();
      }
    });
  }

  openDeleteDialog(note: PublisherNote) {
    this.matDialog.open(ConfirmDialogComponent).afterClosed().subscribe(result => {
      if (result) {
        this.gss.showLoader();
        this.service.deletePublisherNotes(note.id).subscribe(next => {
          this.gss.hideLoader();
          this.sbs.success('Note deleted successfully');
          this.notes = this.notes.filter(item => item.id !== note.id); // remove deleted note from view
        }, error => {
          this.gss.hideLoader();
        });
      }
    });
  }

}
